import * as CONST from "./actionTypes";

const intialState = {
  categories: [],
  error: null,
  loading: false,
};

const DocumentCategoryReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.DOCUMENT_CATEGORY_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case CONST.DOCUMENT_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
        loading: false,
      };
    case CONST.DOCUMENT_CATEGORY_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.EDIT_DOCUMENT_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.EDIT_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
      };
    case CONST.EDIT_DOCUMENT_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_DOCUMENT_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: { ...payload },
        error: null,
      };
    case CONST.UPDATE_DOCUMENT_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_DOCUMENT_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: { ...payload },
        error: null,
      };
    case CONST.ADD_DOCUMENT_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_DOCUMENT_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
      };
    case CONST.DELETE_DOCUMENT_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default DocumentCategoryReducer;
